module.exports = __webpack_public_path__ + "img/logo_white_replace.f9d84b15.png";